import * as React from 'react'
import { FC } from 'react'

import Box from '@mui/material/Box'

interface Props {
  children: React.ReactNode
}

export const EntityCardHeader: FC<Props> = (props) => {
  const { children } = props

  return (
    <Box p={2} pb={0}>
      {children}
    </Box>
  )
}

EntityCardHeader.displayName = 'EntityCardHeader'
